import React from 'react';
import AboutUs from '../Components/layouts/aboutus/AboutUs';

function AboutPage() {
	return (
		<div >
			<AboutUs />
		</div>
	);
}

export default AboutPage;
